import React from "react"
import { MantineProvider, createTheme } from "@mantine/core"
import "@mantine/core/styles.css"
import { CartProvider } from "./src/context/CartContext"

const theme = createTheme({
  primaryColor: "yellow",
  colors: {
    yellow: [
      "#fffbe6",
      "#fff5cc",
      "#ffeb99",
      "#ffe066",
      "#ffd633",
      "#f2bd04", // Primary shade (index 5)
      "#d9a602",
      "#b38600",
      "#8c6800",
      "#664c00",
    ],
  },
  fontFamily: "Domine, serif",
  defaultRadius: "sm",
  components: {
    Button: {
      defaultProps: {
        style: {
          fontFamily: "'Nunito Sans', sans-serif",
        },
      },
    },
    Text: {
      defaultProps: {
        style: {
          fontFamily: "'Nunito Sans', sans-serif",
        },
      },
    },
    List: {
      defaultProps: {
        style: {
          fontFamily: "'Nunito Sans', sans-serif",
          color: "var(--mantine-color-dimmed)",
        },
      },
    },
  },
})

export const wrapRootElement = ({ element }) => (
  <MantineProvider theme={theme}>
    <CartProvider>{element}</CartProvider>
  </MantineProvider>
)

